import { render, staticRenderFns } from "./AppCampaignGroup.vue?vue&type=template&id=95cdd912&"
import script from "./AppCampaignGroup.vue?vue&type=script&lang=js&"
export * from "./AppCampaignGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports